// @flow

// Utility function for triggering logout from anywhere in the app
// This avoids circular dependencies and provides a clean interface

let logoutHandler = null;

// Register the logout handler (called once during app initialization)
export const registerLogoutHandler = (handler: Function) => {
  logoutHandler = handler;
};

// Trigger logout (can be called from anywhere)
export const triggerLogout = async () => {
  if (logoutHandler) {
    try {
      await logoutHandler();
    } catch (error) {
      console.error('[authUtils] Error during logout:', error);
    }
  } else {
    // Fallback: redirect to login if no handler registered
    console.warn('[authUtils] No logout handler registered, redirecting to login');
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
  }
};